import script from "./jsOnceImg1.vue?vue&type=script&setup=true&lang=js"
export * from "./jsOnceImg1.vue?vue&type=script&setup=true&lang=js"

import "./jsOnceImg1.vue?vue&type=style&index=0&id=e988b57c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e988b57c"]])

export default __exports__